import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TransectMesure } from 'src/app/domain/MGCE/transect-mesure';

@Component({
    selector: 'app-transect-measure-box',
    templateUrl: './transect-measure-box.component.html',
    styleUrls: ['./transect-measure-box.component.scss']
})
export class TransectMeasureBoxComponent implements OnInit {
    public DMAX = 100; // m
    // ValidDistanceRiveMax = new FormControl(0, [Validators.max(this.DMAX)]);
    // ValidProfondeurMax = new UntypedFormControl(0, [Validators.max(this.DMAX)]);
    mesureList: TransectMesure[] = [];

    constructor(
        public dialogRef: MatDialogRef<TransectMeasureBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {

            console.log(data)
        if (data) {
            this.mesureList = data;
        }

    }
    ngOnInit(): void {
        // this.ValidDistanceRiveMax.markAsTouched();
        // this.ValidProfondeurMax.markAsTouched();

        let roomAvailableToFitMax = 20 - this.mesureList.length
        if (this.mesureList && roomAvailableToFitMax > 0)
            for (var i = 0; i < roomAvailableToFitMax; i++) {
                this.mesureList.push(new TransectMesure());
            }
    }

    CanAddNewMeasure() {
        // return this.newMesure.DistanceRive && this.newMesure.Profondeur;
        // && this.ValidLmMax.valid && this.ValidLpBMax.valid;
        return true
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.mesureList);
    }
}
